/*	MARK: Samantia Machine Forecast
	============================================
 */
/** Imports **/
import { inject, PLATFORM } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request } from '../services/data-service';
import { Api } from '../services/api';
import { MachineStatus, MachineSignal } from './machine-schemas';

@inject(DataService, Api, Router)
export class MachineRetrain {
	/** Components methods **/
	constructor(ds, api, router){
		// Services
		this.ds			= ds;
		this.api		= api;
		this.router		= router;
		// Custom components vars
		this.selectedDataset = null;
		this.editDataset	 = null;
		
	}
	activate(params){ this.id = params.id } // MachineID
	attached(){window.setTimeout( () =>{this.init();}, 300);}

	/**	MARK: Custom methods
		============================================
	 **/

	init(){
		let machine = this.ds.app_data.machine;
		if(machine){
			this.machine = machine;
			this.dataset = this.ds.app_data.dataset;
			// selected dataset
		}
		else{
			// Get remote machine data
			this.getMachine(this.id).then(response => {
				this.handleMachineResponse(response);
				// Get dataset?
				// selected dataset
			})
		}
		
		let datasets = this.ds.app_data.datasets;
		if(!datasets){
			this.getUserDatasets().then(response =>{
				this.handleResponseUserDatasets(response);
				// Select dataset default
				//console.log("datasets A => ", this.datasets);
				//console.log(this.machine.dataset);
				this.selectedDataset = this.datasets.filter( (dataset) => dataset.file_name === this.machine.dataset)[0];
				//console.log("selected dataset A =>", this.selectedDataset);
			});
		}
		else{
			this.datasets = datasets;
			// Select dataset default
			//console.log("datasets B => ", this.datasets);
			this.selectedDataset = this.datasets.filter( (dataset) => dataset.file_name === this.machine.dataset)[0];
			//console.log("selected dataset B =>", this.selectedDataset);
		}
	}

	/*	MARK: Api calls
		============================================
	 */

	getUserDatasets(){
		let uid 	= this.ds.user.uid;
		let request = new Request("/api/v2/users/" +uid+ "/datasets/", "GET");
		return this.api.get(request);
	}

	handleResponseUserDatasets(response){
		let status = response.status;
		if(status === 200){
			let datasets 	= response.data;
			this.datasets 	=  datasets;
			this.ds.app_data.datasets = datasets;
		}
	}

	getMachine(id){
		// Request
		let request 	= new Request("/api/v2/machines/id?", "GET");
		let params  	= new URLSearchParams({ id:id });
		request.url 	= request.url + params;
		// Perform remote call
		return this.api.get(request);
	}

	handleMachineResponse(response){
		let status = response.status;
		if(status === 200){
			let machine  = response.data;
			this.machine = machine
			this.ds.app_data.machine = machine;
		};
	}
	

	updateMachine(machine, fields){
		let request = new Request("/api/v2/machines/", "PUT");
		let body		= { machine: machine, fields:fields };
		request.body	= JSON.stringify(body);
		return this.api.put(request);
	}

	handleResponseMachineUpdate(response){
		// console.log("update response => ", response);
	}

	deleteDataset(id){
		// Request
		let request 	= new Request("/api/v2/datasets/id/_id?", "DELETE");
		let params  	= new URLSearchParams({ _id:id });
		request.url 	= request.url + params;
		return this.api.remove(request);
	}

	handleDeleteDataset(response){
		console.log("delete datset => ", response);	
	}

	/*	MARK: Transition methods
		============================================
	 */
	next(){
		let machine = this.ds.app_data.machine;
		let id		= machine._id
		let selectedDataset = this.selectedDataset.file_name
		// Update machine (frontend)
		machine.dataset = selectedDataset; // Path
		let dataset_info = { name:this.selectedDataset.name, size:this.selectedDataset.size };
		machine.dataset_info = dataset_info;
		
		this.ds.app_data.dataset = this.selectedDataset // Complete document
		this.updateMachine(machine, { "dataset":selectedDataset, "dataset_info":dataset_info }).then(response => {
			// Handle response
			this.handleResponseMachineUpdate(response);
		})
		.finally( () => {
			this.router.navigateToRoute("models.settings", { id: id });
		});
		
	}

	/* 	MARK: Operation methods
		============================================
	 */

	// New Dataset
	newDataset(){
		let id		= this.id;
		// Navigate to new dataset
		this.router.navigateToRoute("models.dataset-new", { id:id })
	}

	removeDataset(dataset){
		let dataset_id = dataset._id;
		this.deleteDataset(dataset_id).then(response => {
			this.handleDeleteDataset(response);
		});
	}

	onSelectDatasetMenu(dataset){
		this.editDataset = dataset;
	}
}
